/**
 * Renders the local calendar day of a `Date` as `DD-MM-YYYY`.
 *
 * The local-frame counterpart of `formatUtcDate`. Used for `type: dateTime`,
 * whose value is an instant a reader expects to see in their own zone: at
 * 23:30 UTC a reader in UTC+2 is already on the next day, and the day shown
 * must agree with the time shown beside it.
 *
 * Never use this for `type: date`. A calendar date has no instant, so shifting
 * it by an offset moves it to the wrong day — that is what `formatUtcDate` is
 * for.
 *
 * @param date A `Date` built from the model's UTC instant.
 * @returns The local day formatted as `DD-MM-YYYY`.
 *
 * @example
 * formatLocalDate(new Date('2026-08-01T23:30:00Z')); // → '02-08-2026' in UTC+2
 */
export function formatLocalDate(date: Date): string {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${day}-${month}-${date.getFullYear()}`;
}
